/**
 * Coups de pouce — Attendu 1042 « Savoir calculer des produits en lien avec
 * les tables : 0,6 × 7 ; 40 × 0,03 » (automatisme 5e).
 *
 * Doctrine exemple modélisant : pas de règle, le déroulé fait le geste, en
 * langue d'élève, par le chemin de la NUMÉRATION (« 42 dixièmes », la
 * verbalisation du corrigé source). Tout vit sur le FAIT SACRIFIÉ 6 × 7
 * (cf. FAIT_SACRIFIE dans gen_1042 : aucune de ses déclinaisons ne sort en
 * tirage) : invariant protégé par cdp1042.self.test.js.
 * Les explications post-réponse spécifiques à l'item vivent dans
 * contenu.explications du gen (« 5 × 4 = 20, donc 0,5 × 4 = 2 »).
 */

const FICHE_PRODUITS = {
    pages: [
        {
            titre: 'Fais pareil avec tes nombres',
            lignes: [
                '0,6 × 7 ?',
                'D\'abord la table : **6 × 7 = 42**.',
                '0,6 c\'est **6 dixièmes** : alors ça fait **42 dixièmes**.',
                '42 dixièmes = **4,2**. Donc **0,6 × 7 = 4,2**.',
            ],
        },
        {
            titre: 'Avec des zéros et une virgule',
            lignes: [
                '60 × 0,07 ?',
                '0,07 c\'est **7 centièmes**. Et **60 × 7 = 420** (la table, avec le zéro).',
                'Donc 60 × 0,07 = **420 centièmes** = **4,2**.',
            ],
        },
    ],
};

const FICHE_DEFI = {
    pages: [
        {
            titre: 'Fais pareil avec tes nombres',
            lignes: [
                '0,6 × 0,7 ?',
                'La table : **6 × 7 = 42**.',
                'Des dixièmes fois des dixièmes, ça fait des **centièmes** : 42 centièmes.',
                '42 centièmes = **0,42**. Donc **0,6 × 0,7 = 0,42**.',
            ],
        },
    ],
};

const CP_1042 = {
    produits_texte_trou_saisie: FICHE_PRODUITS,
    habillage_qcm: FICHE_PRODUITS,
    produit_saisie: FICHE_PRODUITS,
    defi_decimal_saisie: FICHE_DEFI,
};

export default CP_1042;
